/** Campos da composição do sistema de alarme/detecção de incêndio na proposta. */

export type TipoCentralAlarmeIncendio = "convencional" | "enderecavel";

export const TIPOS_CENTRAL_ALARME_INCENDIO = [
  { value: "convencional", label: "Convencional" },
  { value: "enderecavel", label: "Endereçável" },
] as const;

export type ComposicaoSistemaIncendioForm = {
  tipoCentral: TipoCentralAlarmeIncendio;
  qtdCentral: string;
  qtdAcionadores: string;
  qtdSirenes: string;
  qtdAvisadores: string;
  qtdDetectores: string;
};

export const COMPOSICAO_SISTEMA_INCENDIO_INICIAL: ComposicaoSistemaIncendioForm = {
  tipoCentral: "convencional",
  qtdCentral: "1",
  qtdAcionadores: "1",
  qtdSirenes: "1",
  qtdAvisadores: "1",
  qtdDetectores: "1",
};

export function rotuloTipoCentralIncendio(tipo: string | null | undefined): string {
  return tipo === "enderecavel" ? "Endereçável" : "Convencional";
}

export function parseQtdIncendio(s: string): number {
  const n = parseInt(String(s).replace(/\D/g, "") || "0", 10);
  if (!Number.isFinite(n) || n < 0) return 0;
  return n;
}

export function quantidadeEquipamentoIncendio(
  id: string,
  composicao: ComposicaoSistemaIncendioForm
): number | null {
  switch (id) {
    case "inc_central_alarme":
      return Math.max(1, parseQtdIncendio(composicao.qtdCentral));
    case "inc_acionadores":
      return parseQtdIncendio(composicao.qtdAcionadores);
    case "inc_sirenes":
      return parseQtdIncendio(composicao.qtdSirenes);
    case "inc_avisadores":
      return parseQtdIncendio(composicao.qtdAvisadores);
    case "inc_detectores":
      return parseQtdIncendio(composicao.qtdDetectores);
    default: {
      return null;
    }
  }
}

export function rotuloAtividadeIncendio(
  id: string,
  label: string,
  composicao: ComposicaoSistemaIncendioForm
): string {
  if (id !== "inc_central_alarme") return label;
  return `Central de alarme (${rotuloTipoCentralIncendio(composicao.tipoCentral).toLowerCase()})`;
}
